/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateWelcomeScreenDataSchema = z.object({
	title: z.string(),
	subtitle: z.string().nullable().optional(),
	description: z.string().nullable().optional(),
	subtext: z.string().nullable().optional(),
	videoUrl: z.string().url().nullable().optional(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
	imageId: z.string().uuid().nullable().optional(),
	logoId: z.string().uuid().nullable().optional(),
})

export type UpdateWelcomeScreenDataSchema = z.infer<typeof updateWelcomeScreenDataSchema>
